import type {
    Logger as AppLogger,
    LoggerFactory as AppLoggerFactory,
} from '@amp/web-apps-logger';

export class LoggerFactory {
    static create(
        loggerFactory: AppLoggerFactory,
        name: string,
    ): LoggerFactory {
        return new LoggerFactory(loggerFactory.loggerFor(name));
    }

    constructor(private readonly logger: AppLogger) {}

    build(label?: string): Logger {
        return new Logger(this.logger, label);
    }
}

export class Logger {
    constructor(
        private readonly logger: AppLogger,
        private readonly label?: string,
    ) {}

    shouldQueueMessages = false;

    log(...args: unknown[]): void {
        this.delegate('info', args);
    }

    warn(...args: unknown[]): void {
        this.delegate('warn', args);
    }

    error(...args: unknown[]): void {
        this.delegate('error', args);
    }

    flushMessages(): void {}

    private delegate(method: 'info' | 'warn' | 'error', args: unknown[]): void {
        if (!this.logger) return;

        const log = this.logger[method].bind(this.logger);

        if (this.label) {
            const prefix = `${this.label}:`;
            const [firstArg, ...rest] = args;

            if (typeof firstArg === 'string') {
                log(`${prefix} ${firstArg}`, ...rest);
            } else {
                log(prefix, ...args);
            }
        } else {
            log(...args);
        }
    }
}
